import { useEffect } from 'react';
import { toast } from 'sonner';
import { DEMO_COPY_REFUSALS, type DemoCopyRefusalCode } from '@altsui/shared';
import { onRefusalCode } from '@/lib/api/apiRequestError';
import { useAuthStore } from '@/stores/authStore';

/** Ask Lionshare is the only place a question is refused, and its panel already says so where the question was asked. */
const SHOWN_IN_PLACE: ReadonlySet<DemoCopyRefusalCode> = new Set(['demo_question_cap']);
const CODES = (Object.keys(DEMO_COPY_REFUSALS) as DemoCopyRefusalCode[]).filter((code) => !SHOWN_IN_PLACE.has(code));

/** The "Preparing your demo" screen already says so; the toast would repeat it for every request made behind it. */
function preparingOnScreen(): boolean {
  const { workspaces, activeFundId, user } = useAuthStore.getState();
  const fundId = activeFundId ?? user?.fundId ?? null;
  return workspaces.some((workspace) => workspace.fundId === fundId && workspace.demoCopy?.status === 'preparing');
}

/** Whatever a private demo copy refuses shows its one plain sentence, whichever screen asked; repeats replace it. */
export function DemoCopyNotice(): null {
  useEffect(() => {
    const stops = CODES.map((code) => onRefusalCode(code, () => {
      if (code === 'demo_copy_preparing' && preparingOnScreen()) return;
      toast(DEMO_COPY_REFUSALS[code].message, { id: code });
    }));
    return () => stops.forEach((stop) => stop());
  }, []);
  return null;
}
